import { AccessRight, AccessRights } from '@shared/api/commonApiInterfaces';

interface UseActionButtonsPermissionsProps {
  campaignAccessRights: AccessRight[];
}

export function useActionButtonsPermissions({ campaignAccessRights }: UseActionButtonsPermissionsProps) {
  const showEditButton =
    campaignAccessRights.includes(AccessRights.EDIT_ALL) ||
    campaignAccessRights.includes(AccessRights.EDIT_BUDGET) ||
    campaignAccessRights.includes(AccessRights.EDIT_END_DATE) ||
    campaignAccessRights.includes(AccessRights.EDIT_TARGETING) ||
    campaignAccessRights.includes(AccessRights.EDIT_BRAND) ||
    campaignAccessRights.includes(AccessRights.EDIT_OVERRIDE_CPM) ||
    campaignAccessRights.includes(AccessRights.EDIT_OVERRIDE_IMPRESSIONS) ||
    campaignAccessRights.includes(AccessRights.EDIT_BONUS_IMPRESSIONS) ||
    campaignAccessRights.includes(AccessRights.EDIT_BONUS_PRICE) ||
    campaignAccessRights.includes(AccessRights.EDIT_INVENTORY) ||
    campaignAccessRights.includes(AccessRights.EDIT_ADDITIONAL_NOTE);

  const canDeleteCampaign = campaignAccessRights.includes(AccessRights.DELETE);
  const canSubmitCampaign = campaignAccessRights.includes(AccessRights.SUBMIT);
  const canApproveCampaign = campaignAccessRights.includes(AccessRights.APPROVE);
  const canApproveCampaignBudget = campaignAccessRights.includes(AccessRights.APPROVE_BUDGET);

  return {
    showEditButton,
    canDeleteCampaign,
    canSubmitCampaign,
    canApproveCampaign,
    canApproveCampaignBudget,
  };
}
